'use strict';

import type { UserNotificationPreference } from '../../Entities/User/UserNotificationPreference';
import { EntityCollection } from '../EntityCollection';

export class UserNotificationPreferenceCollection extends EntityCollection<UserNotificationPreference> {}
